import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './end_user_confirm.routes';
import EndUserConfirmService from '../../components/api/end_user_confirm/end_user_confirm.service'

export class EndUserConfirmController {
    /*@ngInject*/
    constructor(EndUserConfirmService, $state, $mdDialog, $stateParams) {
        this.EndUserConfirmService = EndUserConfirmService;
        this.query = {};
        this.query.token = $stateParams.token;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.dialog = {
            error: $mdDialog.alert({
                disableParentScroll: false,
                title: 'パスワードの設定に失敗しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            }),
            success: $mdDialog.alert({
                disableParentScroll: false,
                title: 'パスワードの設定が完了しました',
                content: 'ログインページに移動します',
                ok: 'OK'
            })
        };
    }

    $onInit() {
    }

    submitConfirm(){
        this.EndUserConfirmService.api.update(
            this.query,
            (okResponse)  => { this.$mdDialog.show(this.dialog.success).finally(() => this.$state.go('login')); },
            (errResponse) => {
                if (errResponse.data.message === 'wrong token') {
                    this.dialog.error.content('パスワード設定用URLが無効です');
                }
                this.$mdDialog.show(this.dialog.error);
            }
        );
    };
}

export default angular.module('leptonApp.endUserConfirm', [uiRouter, EndUserConfirmService])
    .config(routing)
    .component('endUserConfirm', {
        template: require('./end_user_confirm.html'),
        controller: EndUserConfirmController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/end_user_confirm/end_user_confirm.component.js